// Styles
import 'vuetify/styles';
// Selbst gehostete Hausschrift des Panels. Variable Achse 100..1000,
// deckt damit die im Design benutzten Schnitte 400/500/600/700 ab.
import '@fontsource-variable/dm-sans';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

// Vuetify
import { createVuetify } from 'vuetify';
// Texte, die Vuetify selbst zeichnet (Tabellenfuss, "Keine Daten", Datumsfelder).
// Welche davon gilt, setzt resources/js/i18n beim Start und beim Sprachwechsel.
import { de, en } from 'vuetify/locale';

// ----------------------------------------------------------------------------
// Theme
//
// Die Werte spiegeln resources/css/_tokens.scss. Beide Dateien beschreiben
// dieselbe Palette: die Tokens fuer handgebaute Bausteine, das Theme fuer
// alles was Vuetify selbst zeichnet. Wer hier etwas aendert, aendert es dort mit.
// ----------------------------------------------------------------------------
const light = {
    dark: false,
    colors: {
        // Grundflaechen
        background:           '#FFFFFF',
        'on-background':      '#12141A',
        surface:              '#FFFFFF',
        'on-surface':         '#12141A',
        // Sekundaerflaeche innerhalb von Karten (Tabellenkopf, Hover-Zeile)
        'surface-variant':    '#EFF3F8',
        'on-surface-variant': '#454C57',

        // Aktionen
        primary:              '#00648F',
        'on-primary':         '#FFFFFF',
        'primary-darken-1':   '#004A6B',
        secondary:            '#454C57',
        'on-secondary':       '#FFFFFF',

        // Status
        error:                '#A01218',
        'on-error':           '#FFFFFF',
        info:                 '#00648F',
        'on-info':            '#FFFFFF',
        success:              '#15803D',
        'on-success':         '#FFFFFF',
        warning:              '#7A4200',
        'on-warning':         '#FFFFFF',

        // ---- Zusatzfarben: erzeugen bg-*, text-* und border-* Klassen -------
        hairline:             '#C3CBD6',
        'on-hairline':        '#12141A',
        'surface-1':          '#EFF3F8',
        'on-surface-1':       '#12141A',
        'surface-2':          '#DBE1EA',
        'on-surface-2':       '#12141A',
        'primary-tint':       '#D8ECF7',
        'on-primary-tint':    '#00648F',
        ink:                  '#12141A',
        'on-ink':             '#FFFFFF',
        muted:                '#454C57',
        'on-muted':           '#FFFFFF',

        // Statusflaechen der Pillen
        neutral:              '#3A4150',
        'on-neutral':         '#FFFFFF',
        'neutral-bg':         '#DDE2EA',
        'on-neutral-bg':      '#3A4150',
        'success-bg':         '#D3ECD9',
        'on-success-bg':      '#15803D',
        'info-bg':            '#CEE7F5',
        'on-info-bg':         '#00648F',
        'warning-bg':         '#F7E6CC',
        'on-warning-bg':      '#7A4200',
        'danger-bg':          '#FBE6E6',
        'on-danger-bg':       '#A01218',

        // Statistik-Reihen
        'data-1':             '#C0121F',
        'on-data-1':          '#FFFFFF',
        'data-2':             '#0098D4',
        'on-data-2':          '#FFFFFF',
    },
    variables: {
        // Abgrenzung laeuft ausschliesslich ueber die Haarlinie, nie ueber Schatten.
        'border-color':          '#C3CBD6',
        'border-opacity':        1,
        // Kein blasser Text: Fliesstext voll deckend, Metatext auf #454C57.
        'high-emphasis-opacity':   1,
        'medium-emphasis-opacity': 0.76,
        // Deaktiviert erkennt man an der Flaeche, nicht an unlesbarem Text.
        'disabled-opacity':        0.72,
        'hover-opacity':           0.06,
        'focus-opacity':           0.10,
        'selected-opacity':        0.10,
        'activated-opacity':       0.10,
        'pressed-opacity':         0.12,
    },
};

export default createVuetify({
    // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
    components,
    directives,
    theme: {
        defaultTheme: 'light',
        themes: { light },
    },
    locale: {
        locale: 'de',
        fallback: 'de',
        messages: { de, en },
    },
    // ------------------------------------------------------------------------
    // Bauteil-Vorgaben
    //
    // Das Design kennt keine Schatten. Formularfelder sind umrandet statt
    // gefuellt. Wo ein Bauteil im Markup etwas anderes mitgibt, gewinnt
    // weiterhin das Markup.
    // ------------------------------------------------------------------------
    defaults: {
        VCard:      { elevation: 0 },
        VBtn:       { elevation: 0, variant: 'flat' },
        VToolbar:   { elevation: 0 },
        VAppBar:    { elevation: 0 },
        VSheet:     { elevation: 0 },
        VMenu:      { offset: 4 },
        VTextField: { variant: 'outlined', color: 'primary' },
        VTextarea:  { variant: 'outlined', color: 'primary' },
        VSelect:    { variant: 'outlined', color: 'primary' },
        VCombobox:  { variant: 'outlined', color: 'primary' },
        VFileInput: { variant: 'outlined', color: 'primary' },
        VSwitch:    { color: 'success', inset: true },
        VCheckbox:  { color: 'primary' },
    },
});
